import { createFileRoute } from "@tanstack/react-router";
import { cecosQueryOptions, clavesSatQueryOptions, cuentasQueryOptions } from "@/features/catalogos/hooks/use-catalogos";
import { ProrrateoSinCfdiPage } from "@/features/prorrateo/components/ProrrateoSinCfdiPage";
import { prorrateoQueryOptions } from "@/features/prorrateo/hooks/use-prorrateo";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/prorrateo-sin-cfdi` · P44 FB60 Contrapago.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/prorrateo-sin-cfdi")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    Promise.all([
      queryClient.ensureQueryData(prorrateoQueryOptions(id)),
      queryClient.ensureQueryData(solicitudQueryOptions(id)),
      queryClient.ensureQueryData(cecosQueryOptions),
      queryClient.ensureQueryData(cuentasQueryOptions),
      queryClient.ensureQueryData(clavesSatQueryOptions),
    ]),
  component: ProrrateoSinCfdiPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
